'use client';

import { closeSnackbar } from 'notistack';
import { type RefObject, useEffect, useRef } from 'react';

import { SnackbarUtils } from '@libs/shared-ui';

import { hideSuccess, useNotificationStore } from '@/shared/notifications';

const dismissActiveSnackbar = (activeNoticeIdRef: RefObject<string | undefined>) => {
    if (!activeNoticeIdRef.current) return;
    closeSnackbar(activeNoticeIdRef.current);
    activeNoticeIdRef.current = undefined;
};

export const SuccessToast = () => {
    const notice = useNotificationStore(state => state.current);
    const isSuccess = notice?.type === 'success';
    const activeNoticeIdRef = useRef<string | undefined>(undefined);

    useEffect(() => {
        if (!isSuccess || !notice) {
            dismissActiveSnackbar(activeNoticeIdRef);
            return;
        }

        if (activeNoticeIdRef.current === notice.id) return;

        dismissActiveSnackbar(activeNoticeIdRef);
        activeNoticeIdRef.current = notice.id;
        SnackbarUtils.show({
            primaryText: notice.message,
            autoDismiss: false,
            preventDuplicate: true,
            key: notice.id,
        });
    }, [isSuccess, notice]);

    useEffect(() => {
        return () => {
            dismissActiveSnackbar(activeNoticeIdRef);
            hideSuccess();
        };
    }, []);

    return null;
};
